/**
 * Public legal pages footer — shown on /login, /mentions-legales,
 * /confidentialite and the public immersion confirm page.
 *
 * Keep it minimal and unauthenticated.
 */
import { Link } from "react-router-dom";


export default function PublicFooter() {
    return (
        <footer
            data-testid="public-footer"
            className="w-full border-t border-shariti-gray bg-shariti-cream/40 py-5 px-6 mt-auto"
        >
            <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-bold uppercase tracking-widest text-slate-500">
                <Link
                    to="/mentions-legales"
                    className="hover:text-shariti-orange transition"
                    data-testid="footer-mentions-legales"
                >
                    Mentions légales
                </Link>
                <span className="text-slate-300">·</span>
                <Link
                    to="/confidentialite"
                    className="hover:text-shariti-orange transition"
                    data-testid="footer-confidentialite"
                >
                    Politique de confidentialité
                </Link>
                <span className="text-slate-300">·</span>
                <a
                    href="mailto:smile@shariti.com"
                    className="hover:text-shariti-orange transition"
                    data-testid="footer-contact"
                >
                    Contact
                </a>
            </div>
            <div className="mt-3 text-center text-[10px] font-medium text-slate-400">
                © {new Date().getFullYear()} Shariti — PREREC · Plateforme interne de prérecrutement
            </div>
        </footer>
    );
}
